import createCachedSelector from 're-reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';
import { IGlobalReduxStore } from 'store';

const selectedScheduleStartDateSelector = createCachedSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => facilityViewState.selectedScheduleStartDate,
)((state: IGlobalReduxStore) => {
  const facilityViewState = scheduleFacilityViewStateSelector(state);
  return `${facilityViewState.selectedScheduleStartDate}` || 'null';
});

export default selectedScheduleStartDateSelector;
